import { useContext } from 'react'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import { hasPermission } from "../../utils/permissions"
import { AuthContext } from '../../context/auth'

const Index = () => {
    const { user } = useContext(AuthContext)
    const userPermissions = user?.user?.teamRole
    return (
        <Layout>
            <HeaderWrapper>
                <div className="header-title">Analytics</div>
            </HeaderWrapper>
            <ContentWrapper>
            {hasPermission(userPermissions?.permissions[0]?.metadata, '/analytics', 'GET', user?.user?.id) 
                ?
                <iframe
                    width='100%'
                    height='100%'
                    src="https://lookerstudio.google.com/embed/reporting/25f8b352-1aba-443b-8f79-233315cc588e/page/kIV1C"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen
                ></iframe>
                :
                    <div className='no-orders'>
                        <span className='icon'>
                            <i class="fal fa-ban"></i>
                        </span>
                        <p>You don't have permission to view this page</p>
                    </div>
                }
            </ContentWrapper>
        </Layout>
    )
}

export default Index